import { Funnel, MembershipStatus, UserWelfareMode } from 'app/src/services/welfareportal/membership-api'

// eslint-disable-next-line import/no-named-as-default
import z from 'zod'

export const membershipStatusSchema: z.ZodType<MembershipStatus> = z.enum(['eligible', 'accepted', 'modified', 'canceled'])

export const userWelfareModeSchema: z.ZodType<UserWelfareMode> = z.enum(['join', 'fruition', 'readonly'])

export const funnelSchema: z.ZodType<Funnel> = z.enum(['DIRECT', 'REFUND', 'TRANSFER', 'PRIZE', 'DISCOUNT'])
